// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { Provider } from 'react-redux';
// import { BrowserRouter } from 'react-router-dom';
// import App from './App';
// import './index.scss';
// import { store } from './redux/store/store';
// import { injectStore } from "./utils/axiosInstance";
// import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';

// injectStore(store);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <DndProvider backend={HTML5Backend}>
//         <App />
//       </DndProvider>
//     </BrowserRouter>
//   </Provider>
// );

import("./bootstrap");